import timezone from 'moment-timezone';
import getFirstParagraph from './getFirstParagraph';

//------------------------------------------------------------------------------
// CONSTANTS FOR WEDDINGS, EVENTS, :
//------------------------------------------------------------------------------
const photographerResponsabilitiesWeddings = ({ organization }) => `
  <h3>Photographer’s Responsibilities.</h3>
  <p>
    ${organization.title} (“Photographer”)
    hereby agrees to perform photographic services for Client at the Event specified above in a professional,
     workmanlike manner according to the prevailing standards in the industry (“Services”). Photographer may
     employ one or more assistants. Photographer is not responsible for the impact on the final product of
     any interference caused by guests or other vendors at the Event. Photographer will make every
     effort to obtain, but cannot guarantee delivery of, any specific images requested by client because of
     Photographer’s lack of control over the Event, its participants, weather, and any rules or restrictions
     of the venue or official conducting the Event.
  </p>
  <p>
    a. If Photographer is exposed to (i) unsafe conditions, or (ii) objectionable or illegal acts at the Event,
    Photographer reserves the right to take reasonable action to remedy such a situation, including but
    not limited to leaving the Event. In such event, Photographer shall not be obligated to refund any of
    the fees paid by Client because of such action.
  </p>
  <p>
    b. Exclusivity. ${organization.title} is to be the only hired photographer at the Event.
  </p>
`;
//------------------------------------------------------------------------------
const retainerAndPaymentWeddings = ({ dueDate }) => `
  <h3>Retainer/Payment.</h3>
  <p>
    A non-refundable retainer (that shall be applied toward the total fee for the Services), 
    as outlined in contract is due upon execution of this agreement, at which time Photographer 
    commits to being available to Client on that date (subject to non-payment, reasonable emergencies 
    and force majeure events). Final payment of the balance due for the Services shall
    be made no later than ${dueDate}. In the event that Client fails to remit payment
    as specified, Photographer shall have the right to immediately terminate this Agreement with no
    further obligation to refund money (including the aforementioned retainer), or to attend the Event.
  </p>
`;
//------------------------------------------------------------------------------
const copyrightWeddings = () => `
  <h3>Copyright.</h3>
  <p>
    All photographs taken by at the Event,
    in whatever form, are copyright protected.
    Any copying, scanning, reprinting, duplicating,
    or altering of the photographs taken by Photographer,
    without Photographer’s express written permission is a
    violation of federal copyright law. The photographs taken
    by Photographer are Photographer’s sole property unless
    purchased by Client.
  </p>
`;
//------------------------------------------------------------------------------
const termsWeddings = () => `
  <h3>Terms.</h3>
  <p>
    The terms of this Agreement shall commence upon the
    execution of this Agreement, and shall terminate upon
    Photographer’s delivery of the final product (Album or Images)
    to the Client, unless terminated earlier as provided herein.
  </p>
`;
//------------------------------------------------------------------------------
const eventChangesCancelationWedding = ({ organization }) => `
  <h3>Event Changes/Cancellation.</h3>
  <p>
    Upon execution of this contract, ${organization.title} reserves the event date solely for contracting party
    and will not take on any other inquiring events for the same day. As such, if the date of the Event changes,
    then Photographer shall be entitled to 75% of retainer as liquidated damages for having to reschedule the event.
    The remainder of the retainer shall be applied toward the new date, but Client shall be responsible for making
    up the deficiency retained as liquidated damages. If Event becomes cancelled, Photographer entitled to 100% of retainer.
  </p>
`;
//------------------------------------------------------------------------------
const deliveryDateWedding = () => `
  <h3>Delivery Date.</h3>
  <p>
    The final images shall be available in online
    viewing/ordering gallery no later than 6 weeks from
    the event date.
  </p>
`;
//------------------------------------------------------------------------------
const modelReleaseWedding = () => `
  <h3>Model Release.</h3>
  <p>
    Client agrees that Photographer may use images of Client
    from any portion of the Work for display, publication,
    or other promotional uses without payment of additional
    ompensation to Client or Client’s agents. Client’s guests
    at the Event shall be deemed to have consented to the use
    of their name, image, or likeness by Client or Photographer
    for the duration of the Event, and Client shall indemnify
     and defend Photographer from and against any claims
    that any of Client’s guests may assert against Photographer
    arising from, or related to, the use of any name, image,
    or likeness of Client’s guests by Photographer.
  </p>
`;
//------------------------------------------------------------------------------
const forceMajeurWedding = () => `
  <h3>Force Majeure.</h3>
  <p>
     If Photographer is unable to attend Event due to fire,
     flood, casualty, strike, civil disturbance, war,
     terrorism, Photographer’s sickness, or other acts of
     God beyond the parties’ control, then Photographer
     shall return all money paid by Client (including
     any retainer), and this agreement shall immediately terminate.
  </p>
`;
//------------------------------------------------------------------------------
const jurisdictionWedding = ({ organization }) => `
  <h3>Jurisdiction.</h3>
  <p>
    The state and federal courts serving this county ${organization.state && `in ${organization.state}`} shall have
    exclusive jurisdiction over disputes arising from this
    Agreement, and both parties hereto consent to the
    jurisdiction of such courts.
  </p>
`;
//------------------------------------------------------------------------------
const attorneyFeesWedding = () => `
  <h3>Attorney’s Fees.</h3>
  <p>
    The prevailing party in any litigation or dispute
    involving this Agreement, or the Services
    performed thereunder, shall be entitled to
    recover reasonable attorney’s fees, costs,
    and expenses arising from such litigation or
    dispute from non-prevailing party.
  </p>
`;
//------------------------------------------------------------------------------
const indemnificationWedding = () => `
  <h3>Indemnification.</h3>
  <p>
    Client hereby acknowledges that Photographer may
    be limited by the guidelines or rules of the official
    performing the ceremony or the venue, and to hold Photographer
    harmless for the impact such restrictions may have on the final product.
  </p>
`;
//------------------------------------------------------------------------------
const limitationOfLiabilityWedding = () => `
  <h3>LIMITATION OF LIABILITY.</h3>
  <p>
    PHOTOGRAPHER’S ENTIRE LIABILITY FOR ANY CLAIM, LOSS, DAMAGE,
    OR INJURY ARISING UNDER OR RELATING TO THIS AGREEMENT
    IS LIMITED TO THE FEES PAID BY CLIENT FOR THE SERVICES.
    IN NO EVENT SHALL PHOTOGRAPHER BE LIABLE FOR SPECIAL,
    INCIDENTAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, EVEN IF
    CLIENT INFORMS PHOTOGRAPHER OF CIRCUMSTANCES THAT WOULD
    GIVE RISE TO SUCH DAMAGES.
  </p>
`;
//------------------------------------------------------------------------------
const eventMealsWedding = () => `
  <h3>Event Meals.</h3>
  <p>
    Client shall arrange with the caterer for meals to be provided to Photographers.
  </p>
`;
//------------------------------------------------------------------------------
const choiceOfLawWedding = () => `
  <h3>Choice of Law.</h3>
  <p>
    This Agreement shall be governed by the laws of the State of California,
    notwithstanding its conflicts of laws provisions.
  </p>
`;
//------------------------------------------------------------------------------
const waiverMiscellaneousWedding = () => `
  <h3>Waiver/Miscellaneous.</h3>
  <p>
    This Agreement represents the complete and entire agreement of the
    parties with respect to the subject matter herein, notwithstanding any oral or written representations to the contrary made before, during, or after its execution. Any amendments to this Agreement shall only be effective if made in writing that is executed by both parties hereto.
  </p>
`;
//------------------------------------------------------------------------------
const protectionOfDeliverablesRetentionOfFilesWedding = () => `
  <h3>Protection of Deliverables/Retention of Files.</h3>
  <p>
    Photographer shall take all reasonable steps to
    protect the images that are recorded at the Event until
    such time as the final images or album are delivered
    to Client. Once the final images or album has been
    delivered, Photographer shall have no further
    obligation to preserve the images of the Event,
    regardless of the form of media in which they are stored.
  </p>
`;
//------------------------------------------------------------------------------
const eventScheduleWedding = ({ organization }) => `
  <h3>Event Schedule.</h3>
  <p>
    The client agrees to confirm the schedule one-week prior to the event. Notification of any changes in schedule or location must be
    made in a timely manner and confirmation of receipt must be obtained by ${organization.title}.
  </p>
`;

const getEventTermsHTML = options => {
  const TIMEZONE = timezone.tz.guess() || 'America/New_York'; // guess users time zone
  const firstParagraph = getFirstParagraph(options);
  const { finalPaymentDueDate, organization } = options;
  const dueDate = finalPaymentDueDate
    ? timezone(finalPaymentDueDate)
      .tz(TIMEZONE)
      .format('dddd, MMMM D YYYY')
    : '';

  return `
      <div>
        ${firstParagraph}
        ${photographerResponsabilitiesWeddings({ organization })}
        ${retainerAndPaymentWeddings({ dueDate })}
        ${copyrightWeddings()}
        ${termsWeddings()}
        ${eventChangesCancelationWedding({ organization })}
        ${deliveryDateWedding()}
        ${modelReleaseWedding()}
        ${forceMajeurWedding()}
        ${jurisdictionWedding({ organization })}
        ${attorneyFeesWedding()}
        ${indemnificationWedding()}
        ${limitationOfLiabilityWedding()}
        ${eventMealsWedding()}
        ${choiceOfLawWedding()}
        ${waiverMiscellaneousWedding()}
        ${protectionOfDeliverablesRetentionOfFilesWedding()}
        ${eventScheduleWedding({ organization })}
      </div>
    `;
};

export default getEventTermsHTML;



// WEBPACK FOOTER //
// ./src/lib/helpers/TextEditorHelpers/getEventTermsHTML.js